import CompanyDetailApp from "company/detail/app";
import CompanyListApp from "company/list/app";
import CompanyMergeApp from "company/merge/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const companyRoute: RouteObject = {
  path: "company",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: CompanyListApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: CompanyDetailApp,
  }, {
    path: ":key/merge/:mergeKey",
    loader: () => viewModel,
    Component: CompanyMergeApp,
  }]
};